import React from "react";

import { ReactComponent as TickIcon } from "src/images/tick.svg";

import "./FieldSelect.scss";

function FieldSelect({
  fieldId,
  fieldTitle,
  capitalize,
  handleClick,
  activeSortingColumn,
}) {
  return (
    <div className="field-select" onClick={handleClick} data-qa={fieldTitle}>
      <span
        className="field-select__data-name"
        style={{ textTransform: capitalize && "capitalize" }}
      >
        {fieldTitle}
      </span>
      {activeSortingColumn === fieldId && <TickIcon />}
    </div>
  );
}

export { FieldSelect };
